import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sponsor } from "../../store/sponsor/actions";
export var useSponsorGetAll = function (trigger, clientId, namesearch, pageSponsor, sponsorLimit) {
    var dispatch = useDispatch();
    var enable = useState(true)[0];
    var _a = useSelector(function (state) { return ({
        responseSponsor: state.Sponsor.responseSponsor,
        errorSponsor: state.Sponsor.errorSponsor,
        loadingSponsor: state.Sponsor.loadingSponsor,
    }); }), responseSponsor = _a.responseSponsor, errorSponsor = _a.errorSponsor, loadingSponsor = _a.loadingSponsor;
    useEffect(function () {
        if (trigger) {
            dispatch(sponsor({
                enable: enable,
                page: pageSponsor,
                limit: sponsorLimit,
                clientId: clientId,
                name: namesearch,
            }));
        }
    }, [trigger]);
    return {
        responseSponsor: responseSponsor,
        errorSponsor: errorSponsor,
        loadingSponsor: loadingSponsor,
    };
};
